import { render, staticRenderFns } from "./HowToWork.vue?vue&type=template&id=128e310c&"
import script from "./HowToWork.vue?vue&type=script&lang=js&"
export * from "./HowToWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports